'use strict';

// ─── Shared Constants ────────────────────────────────────────────────────────
// Polk demographic segment parameters — do not change without Honda analytics team approval
var POLK_PARAMS = '_32900_0_0_0_66_1498_1248_6.2_1_1_0_0_4_142';

/**
 * Parse the configurator footer location elements into a structured object.
 * @returns {{ formattedAddress: string, postalCode: string, dealerName: string }}
 */
function getConfiguratorLocation() {
    var inputLocation = document.getElementById('configurator-footer-location-summary')
        ? document.getElementById('configurator-footer-location-summary').textContent.trim()
        : '';
    var dealerName = document.getElementById('configurator-footer-dealer-name')
        ? document.getElementById('configurator-footer-dealer-name').textContent.trim()
        : '';
    var parts = inputLocation.match(/^(.*)\s(\d{4,5})$/);
    return {
        formattedAddress: parts ? parts[1] : inputLocation,
        postalCode: parts ? parts[2] : '',
        dealerName: dealerName
    };
}

/**
 * Build the `selectedModel` payload from configurator product data + accessories.
 * Replaces the duplicated inline block across save/test-drive/finance callbacks.
 * @param {Object} productData       - summaryData.data.product
 * @param {Array}  accessoriesData   - array of accessory objects (optional)
 * @returns {Object} selectedModel ready to push into models[]
 */
function buildConfiguratorSelectedModel(productData, accessoriesData) {
    var selectedModel = {
        segments: productData.customProps.Body || '',
        displayTitle: productData.productName || '',
        title: productData.productName || '',
        code: productData.customProps.HesCode || '',
        sf_model: productData.customProps.Model || '',
        sf_grade: productData.customProps.grade || '',
        sf_door: productData.customProps.Doors || '',
        sf_year: productData.customProps.Year || '',
        year: productData.customProps.Year || '',
        variants: []
    };
    var variantData = {
        title: (productData.variationAttributes && productData.variationAttributes[1])
            ? productData.variationAttributes[1].displayValue || ''
            : '',
        code: productData.customProps.HesCode || '',
        isDefaultVariant: false,
        transmission: productData.customProps.trans || '',
        sfGrade: productData.customProps.grade || '',
        sfDoor: productData.customProps.doors || '',
        subvariants: []
    };
    var subVariantData = {
        title: (productData.variationAttributes && productData.variationAttributes[0])
            ? productData.variationAttributes[0].displayValue || ''
            : '',
        exterior_color_code: productData.customProps.color || '',
        colorPrice: '0',
        polkParams: POLK_PARAMS,
        isDefaultSubvariant: true,
        accesories: accessoriesData || []
    };
    variantData.subvariants.push(subVariantData);
    selectedModel.variants.push(variantData);
    return selectedModel;
}

module.exports = {
    POLK_PARAMS: POLK_PARAMS,
    getConfiguratorLocation: getConfiguratorLocation,
    buildConfiguratorSelectedModel: buildConfiguratorSelectedModel
};
